import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBuildingState } from "../../../store/actions/permitFormActions/buildingStateActions";
import { privateProviderLabel } from "../../../data/buildingPermit/fieldDatas";
import { fieldsToCheckPrivateProvider } from "../../../data/permitFormsData";
import { formikRef } from "../../../store/formikStore/formikStore";
import { LoadingButton } from "@mui/lab";
import {
  handleSaveProjects,
  pushNewPrivateProvider,
} from "../../../store/actions/dataActions";

const AddingNewPrivateProviderModal = () => {
  const formik = formikRef.current;
  const dispatch = useDispatch();

  const { addingNewPrivateProvider, privateProviderLoading } = useSelector(
    (state) => state.buildingState
  );

  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [fieldValues, setFieldValues] = useState({
    pp_company_name: "",
    pp_address: "",
    pp_phone: "",
    pp_email: "",
    pp_name: "",
    pp_license: "",
  });

  useEffect(() => {
    const callFunc = () => {
      let error = false;

      // Check required fields - at least company name should be filled
      if (!fieldValues.pp_company_name || fieldValues.pp_company_name.trim().length < 3) {
        error = true;
      }

      setSubmitDisabled(error);
    };

    callFunc();
  }, [fieldValues]);

  const runFieldChange = (event) => {
    const { name, value } = event.target;

    setFieldValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddNew = async () => {
    try {
      await dispatch(setBuildingState({ privateProviderLoading: true }));

      const newID = Date.now().toString();
      const createdAt = Math.floor(Date.now() / 1000);

      const savedProjectObj = {
        id: newID,
        pp_company_name: fieldValues.pp_company_name || "",
        pp_address: fieldValues.pp_address || "",
        pp_phone: fieldValues.pp_phone || "",
        pp_email: fieldValues.pp_email || "",
        pp_name: fieldValues.pp_name || "",
        pp_license: fieldValues.pp_license || "",
        created_at: createdAt,
      };

      await dispatch(
        pushNewPrivateProvider(savedProjectObj)
      );

      await dispatch(handleSaveProjects());
      formik?.setValues((prevValues) => ({
        ...prevValues,
        privateProvider: newID,
        pp_company_name: fieldValues.pp_company_name,
        pp_address: fieldValues.pp_address,
        pp_phone: fieldValues.pp_phone,
        pp_email: fieldValues.pp_email,
        pp_name: fieldValues.pp_name,
        pp_license: fieldValues.pp_license,
      }));

      dispatch(setBuildingState({ addingNewPrivateProvider: false }));
      // Reset field values
      setFieldValues({
        pp_company_name: "",
        pp_address: "",
        pp_phone: "",
        pp_email: "",
        pp_name: "",
        pp_license: "",
      });
    } catch (e) {
      console.error("Error adding private provider:", e);
    } finally {
      await dispatch(setBuildingState({ privateProviderLoading: false }));
    }
  };

  const handlePhoneInputChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-digits
    if (value.length > 10) value = value.slice(0, 10);

    let formatted = "";
    if (value.length > 0) {
      if (value.length <= 3) {
        formatted = value;
      } else if (value.length <= 6) {
        formatted = `${value.slice(0, 3)}-${value.slice(3)}`;
      } else {
        formatted = `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6)}`;
      }
    }

    setFieldValues((prev) => ({
      ...prev,
      pp_phone: formatted,
    }));
  };

  return (
    <Modal
      open={addingNewPrivateProvider}
      onClose={() => {
        dispatch(setBuildingState({ addingNewPrivateProvider: false }));
        setFieldValues({
          pp_company_name: "",
          pp_address: "",
          pp_phone: "",
          pp_email: "",
          pp_name: "",
          pp_license: "",
        });
      }}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 500 },
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          maxHeight: "90vh",
          overflow: "auto",
        }}
      >
        <Typography id="modal-title" variant="h6" component="h2" mb={2}>
          Add New Private Provider
        </Typography>

        {fieldsToCheckPrivateProvider.map((field, i) => (
          <TextField
            key={field + i}
            fullWidth
            margin="normal"
            variant="filled"
            label={privateProviderLabel[field]}
            name={field}
            value={fieldValues[field] || ""}
            onChange={
              field === "pp_phone"
                ? handlePhoneInputChange
                : runFieldChange
            }
            required={field === "pp_company_name"}
            error={
              field === "pp_company_name" &&
              fieldValues.pp_company_name &&
              fieldValues.pp_company_name.trim().length < 3
            }
            helperText={
              field === "pp_company_name" &&
              fieldValues.pp_company_name &&
              fieldValues.pp_company_name.trim().length < 3
                ? "Firm Name must be at least 3 characters"
                : ""
            }
          />
        ))}

        <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Button
            onClick={() => {
              dispatch(setBuildingState({ addingNewPrivateProvider: false }));
              setFieldValues({
                pp_company_name: "",
                pp_address: "",
                pp_phone: "",
                pp_email: "",
                pp_name: "",
                pp_license: "",
              });
            }}
          >
            Cancel
          </Button>
          <LoadingButton
            loading={privateProviderLoading}
            variant="contained"
            onClick={handleAddNew}
            disabled={submitDisabled}
          >
            Save
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default React.memo(AddingNewPrivateProviderModal);

